module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "image",
    staticClass: "el-image"
  }, [(_vm.loading) ? _vm._t("placeholder", function() {
    return [_c('div', {
      staticClass: "el-image__placeholder"
    })]
  }) : (_vm.error) ? _vm._t("error", function() {
    return [_c('div', {
      staticClass: "el-image__error"
    }, [_vm._v("\n      " + _vm._s(_vm.t('el.image.error')) + "\n    ")])]
  }) : _c('img', _vm._g(_vm._b({
    staticClass: "el-image__inner",
    class: {
      'el-image__inner--center': _vm.alignCenter,
      'el-image__preview': _vm.preview
    },
    style: (_vm.imageStyle),
    attrs: {
      "src": _vm.src
    },
    on: {
      "click": _vm.clickHandler
    }
  }, 'img', _vm.$attrs, false), _vm.$listeners)), _vm._v(" "), (_vm.preview) ? [(_vm.showViewer) ? _c('image-viewer', {
    attrs: {
      "z-index": _vm.zIndex,
      "initial-index": _vm.imageIndex,
      "on-close": _vm.closeViewer,
      "url-list": _vm.previewSrcList
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f231833"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/imagePreview/rtImagePreview.vue
// module id = 2019
// module chunks = 228